import angular from 'angular';
import {
  ecatDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-assessment-document-dialog.controller';
import template from './edit-assessment-document-dialog.html';
import ecatDocumentAttachmentNameMessagesTpl from './messages/ecat-document-attachment.name.messages.html';
import ecatDocumentAttachmentTypeMessagesTpl from './messages/ecat-document-attachment.type.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

class dialogService {
  getOptions($event, {
    assessment,
    document,
    documentTypes,
  }) {
    return {
      controller,
      controllerAs: 'editAssessmentDocumentDialogVM',
      locals: {
        assessment,
        document,
        documentTypes,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.editAssessmentDocumentDialog', [
  alerts,
  ecatDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('editAssessmentDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('ecat-document-attachment.name.messages.html', ecatDocumentAttachmentNameMessagesTpl);
    $templateCache.put('ecat-document-attachment.type.messages.html', ecatDocumentAttachmentTypeMessagesTpl);
  })
  .name;
